export const countDecimalPlaces = (value) => {
  if (!value) {
    return 0;
  }

  const parts = String(value).split('.');
  return parts.length === 2 ? parts[1].length : 0;
};

export const getToleranceSigns = (toleranceType) => {
  switch (toleranceType) {
    case 'positive':
      return { first: '+', second: '+' };
    case 'negative':
      return { first: '-', second: '-' };
    default:
      return { first: '+', second: '-' };
  }
};

export const getToleranceDecimals = (inspection, minimumDecimals = 0) =>
  Math.max(
    minimumDecimals,
    countDecimalPlaces(inspection.expectedValue),
    countDecimalPlaces(inspection.positiveTolerance),
    countDecimalPlaces(inspection.negativeTolerance)
  );

export const getToleranceLimits = (inspection) => {
  const expectedValue = parseFloat(inspection.expectedValue);
  const positiveTolerance = parseFloat(inspection.positiveTolerance) || 0;
  const negativeTolerance = parseFloat(inspection.negativeTolerance) || 0;

  let lowerLimit;
  let upperLimit;
  switch (inspection.toleranceType) {
    case 'positive':
      lowerLimit = Math.min(
        expectedValue + positiveTolerance,
        expectedValue + negativeTolerance
      );
      upperLimit = Math.max(
        expectedValue + positiveTolerance,
        expectedValue + negativeTolerance
      );
      break;
    case 'negative':
      lowerLimit = Math.min(
        expectedValue - positiveTolerance,
        expectedValue - negativeTolerance
      );
      upperLimit = Math.max(
        expectedValue - positiveTolerance,
        expectedValue - negativeTolerance
      );
      break;
    default:
      lowerLimit = expectedValue - negativeTolerance;
      upperLimit = expectedValue + positiveTolerance;
  }

  const decimalPlaces = getToleranceDecimals(inspection);
  return [
    parseFloat(lowerLimit.toFixed(decimalPlaces)),
    parseFloat(upperLimit.toFixed(decimalPlaces)),
  ];
};

export const getToleranceDeviation = (measurement, inspection) => {
  const [lowerLimit, upperLimit] = getToleranceLimits(inspection);
  if (measurement < lowerLimit) return measurement - lowerLimit;
  if (measurement > upperLimit) return measurement - upperLimit;
  return Number.isNaN(lowerLimit) || Number.isNaN(measurement) ? NaN : 0;
};

export const formatToleranceDeviation = (
  deviation,
  measurementValue,
  decimalPlaces
) =>
  deviation.toFixed(
    Math.max(decimalPlaces, countDecimalPlaces(measurementValue))
  );
